module.exports = __webpack_public_path__ + "static/media/logoBakiyem.c6894275.png";